'use strict';

import { combinereducers } from 'redux';
import update from 'immutability-helper';
import * as types from './types';
import * as dTypes from '@/state/domains/assignments/types';
import * as jTypes from '@/state/domains/orders/types';

export default (
    state = {
		location: {},
		urlParams: {},
		actionMode: 'select',
		isMenuOpen: false,
		page: '',
		responsive: {},
		pageContext: {},
		pageLoaded: {},
		pageUrl: '',
		routerInProgress: false,
		modals: {
			importJobs: false,
			addToRoute: false,
			deleteJobs: false,
			createUser: false,
			editUser: false,
			deleteUser: false,
			editAttempt: false,
			deleteAttempt: false,
			undoComplete: false,
			userSettings: false,
			assignUser: false,
		},
		nav: {
			week: {
			},
			day: {
			},
		},
		modalProps: {},
		jobId: null,
		companyId: null,
		usersLoaded: false,
	},
    action
) => {

	let selected, newSelected;

    switch (action.type) {

		case types.UPDATE_LOCATION:
			return {
				...state,
				location: action.data,
			};

		case types.UPDATE_CLIENT_WIDTH:
			return { ...state, clientWidth: action.data };

		case types.UPDATE_URL_PARAMS:
			return { ...state, urlParams: action.data };

		case types.SET_ACTION_MODE:
			return { ...state, actionMode: action.data };

		case types.SET_PAGE:
			return { ...state, page: action.data };

		case types.SET_RESPONSIVE:
			return { ...state, responsive: action.data };

		case types.SET_PAGE_CONTEXT:
			return { ...state, context: action.data };

		case types.SET_PAGE_LOADED:
			return {
				...state,
				pageLoaded: {
					...state.pageLoaded,
					[ action.data ]: true,
				},
			};

		case types.SET_PAGE_ID:
			return { ...state, pageId: action.data };

		case types.SET_ROUTER_IN_PROGRESS:
			return { ...state, routerInProgress: true };

		case types.UNSET_ROUTER_IN_PROGRESS:
			return { ...state, routerInProgress: false };

		case types.SET_MODAL_OPEN:

			const modalProps = action.data.props || {};
			modalProps.id = action.data.id;

			return {
				...state,
				modals: {
					...state.modals,
					[ action.data.id ]: true
				},
				modalProps,
			};

		case types.SET_MODAL_CLOSE:
			return { ...state, modals: { ...state.modals, [ action.data ]: false }};

		case types.SET_JOB:
			return {
				...state,
				jobId: action.data.jobId,
				companyId: action.data.companyId,
			};

		case types.SET_MENU_OPEN:
			return {
				...state,
				isMenuOpen: true,
			};

		case types.SET_MENU_CLOSE:
			return {
				...state,
				isMenuOpen: false,
			};

		case jTypes.POST_ASSIGN_JOBS_COMPLETED:

			const { username, date } = action.data;
			const url = `/user/${ username }/${ date }/route`;

			return {
				...state,
				pageLoaded: {
					...state.pageLoaded,
					[ url ]: false,
				},
			};

		case types.GET_WEEK_NAV_COMPLETED:

			const { date: weekDate, prevWeek, nextWeek } = action.data;

			return {
				...state,
				nav: {
					...state.nav,
					week: {
						...state.nav.week,
						[ weekDate ]: {
							prev: prevWeek,
							next: nextWeek,
						},
					},
				},
			};

		case types.GET_DAY_NAV_COMPLETED:

			const { date: dayDate } = action.meta.params;
			const { prevDay, nextDay } = action.data;

			return {
				...state,
				nav: {
					...state.nav,
					day: {
						...state.nav.day,
						[ dayDate ]: {
							prev: prevDay,
							next: nextDay,
						},
					},
				},
			};

		case types.SET_USERS_LOADED:
			return {
				...state,
				usersLoaded: true,
			};

		default:
			return state;
	}
};
